import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    showCreateProblemSetModal: false,
    editingProblemSetId: null,
    gradesProblemSetId: null,
}

const problemSetsSlice = createSlice({
    name: 'problemSets',
    initialState,
    reducers: {
        toggleCreateProblemSetModal: state => {
            state.showCreateProblemSetModal = !state.showCreateProblemSetModal
        },
        setEditingProblemSetId: (state, action) => {
            state.editingProblemSetId = action.payload
        },
        setGradesProblemSetId: (state, action) => {
            state.gradesProblemSetId = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const { toggleCreateProblemSetModal, setEditingProblemSetId, setGradesProblemSetId } = problemSetsSlice.actions

export default problemSetsSlice.reducer
